import { createAction, props } from '@ngrx/store';
import { SelectOption } from '@uc/web/shared/data-models';

//generic error handling
export const loadAdviceFailure = createAction(
	'[AdviceState] Load Advice Failure',
	props<any>(),
);

//get categories actions
export const fetchCategories = createAction('[AdviceState/API] Fetch Categories');

export const updateCategories = createAction(
	'[AdviceState] Update Categories',
	props<{ categories: SelectOption[] }>(),
);

//get all articles
export const fetchAllArticles = createAction('[AdviceState/API] Fetch All Articles');

export const updateAllArticles = createAction(
	'[AdviceState] Update All Articles',
	props<{ articles: any }>(),
);

//get featured and editor's choice
export const fetchFeatured = createAction('[AdviceState/API] Fetch Featured');

export const fetchFeaturedWithCategory = createAction(
	'[AdviceState/API] Fetch Featured With Category',
	(categoryKey = '') => ({ categoryKey }),
);

export const updateFeatured = createAction(
	'[AdviceState] Update Featured',
	props<{ featured: any }>(),
);

//get single artice
export const fetchSingleArticle = createAction(
	'[AdviceState/API] Fetch Single Article',
	(articleUrl: string, categoryUrl: string) => ({ articleUrl, categoryUrl }),
);

export const updateSingleArticle = createAction(
	'[AdviceState] Update Single Article',
	props<{ singleArticle: any }>(),
);

// search advice
export const fetchSearchAdvice = createAction(
	'[AdviceState/API] Fetch Search',
	(search = '', page = 1, offset = 0) => ({
		search,
		page,
		offset,
	}),
);

export const updateSearchParams = createAction(
	'[AdviceState] Set Search Params',
	props<{ searchTerm: string; page: number; offset: number }>(),
);

export const updateSearchAdvice = createAction(
	'[AdviceState] Update Search',
	props<{ search: any }>(),
);
